import React, { Component } from 'react';
import { Divider, Dimmer, Loader, Segment } from 'semantic-ui-react'
import AccountItem from "../AccountItem/index";
import AccountHeader from "../AccountHeader/index";
import { overviewAccountsURL } from "../../shared/urls/clientapi";
import { callService, GET } from "../../shared/serviceInvoker";
import AddDebtModal from "../AddDebtModal";

export default class AccountsList extends Component {

  constructor(props) {
    super(props);
    this.state = { data: [], showLoader: true, show_debt_link: false }
  }

  componentDidMount() {
    var contact_id = "";
    if (sessionStorage.getItem("contact_id")) {
      contact_id = sessionStorage.getItem("contact_id");
    }

    callService(
      GET,
      overviewAccountsURL.replace('{contact_id}', contact_id),
      null,
      response => {
        let result = response.data.data;
        let show_link = result[3].show_debt_link
        this.setState({ data: result, showLoader: false, show_debt_link: show_link });
      },
      error => {
        let result = [];
        this.setState({ data: result, showLoader: false, show_debt_link: false });
      }
    );
  }

  render() {
    const { showLoader } = this.state;
    const PageLoader = () => (
      <Dimmer active={showLoader} inverted>
        <Loader size='medium'>Loading Accounts ...</Loader>
      </Dimmer>
    )

    let accounts = this.state.data.map((account_grouping, index) =>
      <div key={index}>
        <PageLoader />
        <p />

        <AccountHeader
          status={account_grouping.status}
          status_info={account_grouping.status_info}
          total_enrolled={account_grouping.total_enrolled}
          total_original_amount={account_grouping.total_original_amount}
        />

        {account_grouping.accounts.map((account) => {
          return (
            <AccountItem
              key={account.debt_id}
              name={account.debt_name}
              last_four={account.debt_account_last_four}
              enrolled_balance={account.debt_amount}
              remaining_payments={account.debt_remaining_payments}
              remaining_amount={account.debt_remaining_amount}
              original_amount={account.debt_original_amount}
            />
          )
        })}
      </div>
    );

    return (
      <div>
        <div><b>MY ACCOUNTS</b></div>
        <div align="right">Balance</div>
        <Divider fitted />
        {accounts}
        {this.state.show_debt_link ?
          <Segment attached >
            <div className="divLeft14">
              <AddDebtModal />
            </div>
          </Segment>
          : null}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/AccountsList/index.js